import { useEffect, useState } from "react";
import swal from 'sweetalert2';
import { updateTeeTimeCancel } from "../api/teeTimeAPI";
import moment from "moment";

const EditTeeTimeCancellation = (props) => {
    console.log(props);
    const [cancellationDetails, setCancellationDetails] = useState({});
    const [combinedFee, setCombinedFee] = useState(null); // ✅ NEW

    // ✅ Combined fee calculator
    const calculateCombinedFees = (greenFeesList) => {
        return greenFeesList.reduce((acc, user) => {
            const g = user.GreenFee || {};
            acc.TotalGreenFee += g.TotalGreenFee || 0;
            acc.CartCount += g.CartCount || 0;
            acc.CaddyCount += g.CaddyCount || 0;
            acc.TotalCartFee += g.TotalCartFee || 0;
            acc.TotalCaddyFee += g.TotalCaddyFee || 0;
            acc.Tax += g.Tax || 0;
            acc.Discount += g.Discount || 0;
            acc.DiscountAmount += g.DiscountAmount || 0;
            acc.TotalAmount += g.TotalAmount || 0;
            acc.FinalAmount += g.FinalAmount || 0;
            acc.Sgst += g.Sgst || 0;
            acc.Cgst += g.Cgst || 0;
            return acc;
        }, {
            TotalGreenFee: 0,
            CartCount: 0,
            CaddyCount: 0,
            TotalCartFee: 0,
            TotalCaddyFee: 0,
            Tax: 0,
            Discount: 0,
            DiscountAmount: 0,
            TotalAmount: 0,
            FinalAmount: 0,
            Sgst: 0,
            Cgst: 0
        });
    };

    useEffect(() => {
        $('#edit-Cancellation-modal').modal({ backdrop: 'static' });
        $('#edit-Cancellation-modal').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            props.onDismissModal(null);
        });
    }, []);

    useEffect(() => {
        if (props.cancellationDetails) {
            setCancellationDetails({ ...props.cancellationDetails });

            // ✅ Calculate combined fees if available
            if (props.cancellationDetails.GreenFees?.length > 0) {
                const combined = calculateCombinedFees(props.cancellationDetails.GreenFees);
                setCombinedFee(combined);
            } else {
                setCombinedFee(null);
            }
        }
    }, [props.cancellationDetails]);

    const updateCancellationDetails = (field, value) => {
        setCancellationDetails((prev) => ({ ...prev, [field]: value }));
    };

    const submitCancellation = async (e) => {
        e.preventDefault();
        var form = $('#cancellationForm');
        form.validate({
            rules: {
                txtRefNo: { required: true },
                txtRefAmount: { required: true }
            },
            messages: {
                txtRefNo: { required: "Please enter Ref No" },
                txtRefAmount: { required: "Please enter Ref Amount" }
            }
        });
        if (!form.valid()) return;

        if (cancellationDetails.RefundAmount > props?.cancellationDetails?.PGAmount) {
            return swal.fire({
                icon: 'warning',
                text: "Refund amount is greater than Bill Amount" ,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand',
            });
        }

        try {
            await updateTeeTimeCancel({
                ID: cancellationDetails.ID,
                RefundRefNo: cancellationDetails.RefundRefNo,
                RefundAmount: cancellationDetails.RefundAmount,
                RefundComment: cancellationDetails.RefundComment
            });
            swal.fire({
                icon: 'success',
                titleText: 'Cancellation updated successfully!',
                showConfirmButton: false,
                timer: 1500,
            });
            setCancellationDetails({});
            $('#edit-Cancellation-modal').modal('hide');
        } catch (err) {
            swal.fire({
                icon: 'error',
                titleText: 'Error!',
                text: err.message,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-brand',
            });
        }

        props.refetchData();
        form.clearForm();
        form.validate().resetForm();
    };

    return (
        <div className="modal fade" id="edit-Cancellation-modal" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Book - {cancellationDetails.TeeBox === 10 ? '10th Tee Box' : '1st Tee Box'}</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form id="cancellationForm">
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Date</label>
                                <div className="col-6">
                                    <input type="text" className="form-control" value={moment(cancellationDetails.CancelDate).format('DD-MM-YYYY') || ''} disabled />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Slot</label>
                                <div className="col-6">
                                    <input type="text" className="form-control" disabled value={cancellationDetails.Slot || ''} readOnly />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Holes</label>
                                <div className="col-6">
                                    <input type="text" className="form-control" disabled value={cancellationDetails.Hole || ''} readOnly />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">User Comment</label>
                                <div className="col-6">
                                    <textarea className="form-control" rows="2" disabled value={cancellationDetails.txtUserComment || ''}></textarea>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Refund Ref No <span className="red">*</span></label>
                                <div className="col-6">
                                    <input type="text" className="form-control" id="txtRefNo" name="txtRefNo" value={cancellationDetails.RefundRefNo || ''} onChange={(e) => updateCancellationDetails('RefundRefNo', e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Refund Amount <span className="red">*</span></label>
                                <div className="col-6">
                                    <input type="text" className="form-control" id="txtRefAmount" name="txtRefAmount" value={cancellationDetails.RefundAmount || ''} onChange={(e) => updateCancellationDetails('RefundAmount', e.target.value)} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-form-label col-4 text-right">Comment</label>
                                <div className="col-6">
                                    <textarea className="form-control" rows="2" value={cancellationDetails.RefundComment || ''} onChange={(e) => updateCancellationDetails('RefundComment', e.target.value)}></textarea>
                                </div>
                            </div>
                        </form>

                        <table className="table table-bordered table-hover margin-b30">
                            <thead className="light-grey-background">
                                <tr>
                                    <th>Players</th>
                                    <th>Category</th>
                                    <th>Cart</th>
                                    <th className="text-center">Caddy</th>
                                </tr>
                            </thead>
                            <tbody>
                                {[1, 2, 3, 4].map((index) => {
                                    const playerKey = `Player${index}`;
                                    const cartKey = `Player${index}Cart`;
                                    const caddyKey = `Player${index}Caddy`;
                                    const userTypeKey = `UserType${index}`;
                                    if (!cancellationDetails[playerKey]) return null;

                                    return (
                                        <tr key={index}>
                                            <td>
                                                <span className={`kt-badge kt-badge--${cancellationDetails[userTypeKey] == "User" ? 'success' : (cancellationDetails[userTypeKey] == "Guest" || cancellationDetails[userTypeKey] == "UsersGuest") ? 'warning' : 'danger'} kt-badge--dot`}></span>
                                                &nbsp;&nbsp;{cancellationDetails[playerKey]}
                                            </td>
                                            <td>{cancellationDetails[playerKey]?.SubCategoryName || ''}</td>
                                            <td>{cancellationDetails[cartKey] === 'Y' ? 'Yes' : 'No'}</td>
                                            <td>{cancellationDetails[caddyKey] === 'Y' ? 'Yes' : 'No'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        <table className="table table-bordered table-hover margin-b30">
                            <thead className="light-grey-background">
                                <tr>
                                    <th>Description</th>
                                    <th className="text-right">Amount (₹)</th>
                                </tr>
                            </thead>
                            <tbody style={{ borderSpacing: "10px" }}>
                                {combinedFee && (
                                    <>
                                        {combinedFee.TotalCartFee > 0 && (
                                            <tr>
                                                <td>
                                                <span>{combinedFee.CartCount}</span>
                                                <span style={{marginLeft:"5px"}}>Cart</span>
                                                </td>
                                                <td className="text-right">₹ {combinedFee.TotalCartFee.toFixed(2)}
                                                </td>

                                            </tr>
                                        )}
                                        {combinedFee.TotalCaddyFee > 0 && (
                                            <tr>
                                                <td>
                                                <span>{combinedFee.CaddyCount}</span>
                                                <span style={{marginLeft:"5px"}}>Caddy</span>
                                                </td>
                                                <td className="text-right">₹ {combinedFee.TotalCaddyFee.toFixed(2)}</td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>SGST (9%)</td>
                                            <td className="text-right">₹ {combinedFee.Sgst.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>CGST (9%)</td>
                                            <td className="text-right">₹ {combinedFee.Cgst.toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Total</strong></td>
                                            <td className="text-right"><strong>₹ {combinedFee.FinalAmount.toFixed(2)}</strong></td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="modal-footer" style={{ marginLeft: 'auto' }}>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-info" onClick={submitCancellation}>Process Refund</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditTeeTimeCancellation;
